import React, { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { getProducts } from '../../utils/productStore';
import { productPath } from '../../utils/routes';
import './Footer.scss';
import logo from '../../assets/logo.jpg';

const companyLinks = [
  { label: 'About Us', href: '/#about' },
  { label: 'Projects', href: '/#projects' },
  { label: 'Clients', href: '/#clients' },
  { label: 'Testimonials', href: '/#testimonials' },
  { label: 'Contact', href: '/#contact' },
];

const supportLinks = [
  { label: 'Get a Quote', href: '/#contact' },
  { label: 'Products', href: '/#materialHandling' },
  { label: 'Service & Maintenance', href: '/#contact' },
  { label: 'Installation Support', href: '/#contact' },
  { label: 'FAQs', href: '/#contact' },
];

const socialLinks = [
  { icon: faFacebookF, label: 'Facebook', href: 'https://facebook.com/share/1FJZ7yDuuS' },
  {
    icon: faWhatsapp,
    label: 'WhatsApp',
    href: 'https://wa.me/919328058417',
  },
  { icon: faInstagram, label: 'Instagram', href: 'https://instagram.com/aavjoindustries?igsh=MWpvYWYya3dxbzBuNg==' },
  { icon: faEnvelope, label: 'Email', href: 'mailto:aavjoindustries@gmail.com' },
];

const Footer = () => {
  const [email, setEmail] = useState('');

  const productCategories = useMemo(() => {
    const seen = new Set();
    return getProducts().reduce((links, product) => {
      if (!seen.has(product.category)) {
        seen.add(product.category);
        links.push({
          label: product.category,
          href: productPath(product),
        });
      }
      return links;
    }, []);
  }, []);

  const handleSubscribe = (e) => {
    e.preventDefault();
    setEmail('');
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row g-5">

          <div className="col-lg-4">
            <div className="footer-brand">
              <div className="brand-wrap">
                <div className="brand-icon">
                  <img src={logo} alt="Aavjo Industries" />
                </div>
                <div className="brand-name">Aavjo Industries</div>
              </div>
              <p className="brand-desc">
                Manufacturer of aerial lifts, scissor lifts, goods lifts, stackers and
                pallet trucks. Precision material handling equipment from Ahmedabad,
                Gujarat, trusted across India.
              </p>
              <div className="footer-socials">
                {socialLinks.map((s) => (
                  <a
                    key={s.label}
                    className="social-icon"
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={s.label}
                    title={s.label}
                  >
                    <FontAwesomeIcon icon={s.icon} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-lg-2">
            <div className="footer-col">
              <h4>Products</h4>
              <ul>
                {productCategories.map((category) => (
                  <li key={category.label}>
                    <a href={category.href}>{category.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-sm-6 col-lg-2">
            <div className="footer-col">
              <h4>Company</h4>
              <ul>
                {companyLinks.map((l) => (
                  <li key={l.label}>
                    <a href={l.href}>{l.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-sm-6 col-lg-2">
            <div className="footer-col">
              <h4>Support</h4>
              <ul>
                {supportLinks.map((l) => (
                  <li key={l.label}>
                    <a href={l.href}>{l.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-sm-6 col-lg-2">
            <div className="footer-col footer-col-newsletter">
              <h4>Stay Updated</h4>
              <div className="newsletter-box">
                <p>Get industry insights and product updates delivered to your inbox.</p>
                <form className="newsletter-form" onSubmit={handleSubscribe}>
                  <input
                    type="email"
                    placeholder="your@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit">Go</button>
                </form>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="bottom-inner">
            <span className="copy">
              © {new Date().getFullYear()} Aavjo Industries Pvt. Ltd. All rights reserved.
            </span>
            <div className="bottom-links">
              <a href="/#contact">Privacy Policy</a>
              <a href="/#contact">Terms of Use</a>
              <a href="/sitemap.xml">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
